import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { ActivatedStepsConditionData } from 'src/app/components/designer/models/activated-steps-condition-data';
import { Step } from 'src/app/components/designer/models/step';
import { FormMode } from 'src/app/controls/common/form-mode';
import { ContextualMenuEvent } from 'src/app/controls/workflows/contextual-menu-event';
import { NeedSteps } from 'src/app/controls/workflows/need-steps';
import { WorkflowDataInterface } from 'src/app/controls/workflows/workflow-data.interface';

@Component({
    selector: 'app-workflow-condition-step-activated-data',
    templateUrl: './workflow-condition-step-activated-data.component.html',
    styleUrls: ['./workflow-condition-step-activated-data.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, FaIconComponent, MatTooltipModule]
})
export class WorkflowConditionStepActivatedDataComponent implements WorkflowDataInterface, OnInit, NeedSteps {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: ActivatedStepsConditionData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string | ActivatedStepsConditionData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as ActivatedStepsConditionData;
        }

        this.fillForm();
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): ActivatedStepsConditionData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Liste des étapes.
     */
    public _steps: Step[];

    /**
     * Spécifie la liste des étapes.
     */
    set steps(value: Step[]) {
        this._steps = value;
        this.fillForm();
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Constructeur.
     */
    constructor() {
        console.log('WorkflowConditionStepActivatedDataComponent - constructor : ');
    }

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        console.log('WorkflowConditionStepActivatedDataComponent - ngOnInit : ');
        this.dataForm = new UntypedFormGroup({
            step: new UntypedFormControl([], [Validators.required]),
        });

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return this.dataForm.valid;
    }

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                this.dataForm.get('step').setValue(this._data.steps);
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: ActivatedStepsConditionData = new ActivatedStepsConditionData();
        updatedData.steps = this.dataForm.get('step').value;

        this._data = updatedData;
    }
}
